import { Component,OnInit } from '@angular/core';
import Swal from 'sweetalert2';
// declare var liff: any;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  title = 'ng-line-liff';
  // messages: string;
  // userProfile: any;
  constructor() {
    // this.messages = "";
    // this.initLineLiff();
  }

  async ngOnInit() {
    // await this.initLineLiff();
  }

  async initLineLiff() {
    // try {
    //   const data: any = await this.initLineLiffSDK();
    //   this.userProfile = await liff.getProfile();
    //   //alert(`Hi ${this.userProfile.displayName}!`);
    // } catch (err) {
    //   // alert(err)
    // }
  }

  async sendMessages() {
    // try {
    //   await liff.sendMessages([
    //     {
    //       type: 'text',
    //       text: this.messages
    //     }
    //   ]).then(() => {
    //     console.log('message sent');
    //   })
    //   .catch((err:any) => {
    //     console.log('error', err);
    //   });
    //   liff.closeWindow()
    //   Swal.fire({
    //     icon:"success",
    //     title:this.messages
    //   });
    // } catch (e) {
    //   alert(e)
    //   Swal.fire({
    //     icon:"error",
    //     title:e
    //   });
    // }

  }
}

